import React from 'react'
import classNames from 'classnames'
import { Image, MostWantedFilled } from 'baby-design/icons'

import { RegItemMinimalCardImageProps } from './RegItemMinimalCardImage.types'
import css from './RegItemMinimalCardImage.styles.scss'
import {
  getQuantityText,
  shouldDisplayMissingImage,
  shouldDisplayQuantity,
} from './RegItemMinimalCardImage.utils'

const RegItemMinimalCardImage: React.FC<RegItemMinimalCardImageProps> = ({
  regItem,
  variant,
}: RegItemMinimalCardImageProps) => {
  const regItemImageClasses = classNames(css.RegItemMinimalCardImage, {
    [css.RegItemMinimalCardImage__Default]: variant === 'Default',
    [css.RegItemMinimalCardImage__Wide]: variant === 'Wide',
  })
  const isQuantityVisible = shouldDisplayQuantity(regItem)
  const quantityDisplayText = getQuantityText(regItem)
  const isMissingImageVisible = shouldDisplayMissingImage(regItem)

  return (
    <div className={regItemImageClasses} data-testid="RegItemMinimalCardImage">
      {isMissingImageVisible && (
        <div
          className={css.RegItemMinimalCardImage__MissingImage}
          data-testid="MissingImage"
        >
          <Image
            dangerouslyOverrideClassName={
              css.RegItemMinimalCardImage__MissingImageIcon
            }
          />
        </div>
      )}
      {!isMissingImageVisible && (
        <img
          alt={regItem.title}
          className={css.RegItemMinimalCardImage__Image}
          data-testid="Image"
          src={regItem.imgUrl}
        />
      )}
      {isQuantityVisible && (
        <div className={css.RegItemMinimalCardImage__Quantity}>
          Wants: {quantityDisplayText}
        </div>
      )}
      {regItem.isFavorite && (
        <MostWantedFilled
          className={css.RegItemMinimalCardImage__MostWantedIcon}
          data-testid="MostWantedIcon"
        />
      )}
    </div>
  )
}

export default RegItemMinimalCardImage
